var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2459 5.80743L6.0627 9.06471C6.01345 9.1026 5.97363 9.15118 5.94632 9.20672C5.91902 9.26225 5.90495 9.32326 5.9052 9.38503V14.6724C5.9052 14.7827 5.94945 14.8885 6.02822 14.9665C6.10698 15.0446 6.21381 15.0884 6.3252 15.0884H8.6352C8.74659 15.0884 8.85342 15.0446 8.93219 14.9665C9.01095 14.8885 9.0552 14.7827 9.0552 14.6724V11.8436C9.0552 11.7333 9.09945 11.6274 9.17822 11.5494C9.25698 11.4714 9.36381 11.4276 9.4752 11.4276H11.55C11.6614 11.4276 11.7682 11.4714 11.847 11.5494C11.9258 11.6274 11.97 11.7333 11.97 11.8436V14.6724C11.97 14.7827 12.0142 14.8885 12.093 14.9665C12.1718 15.0446 12.2786 15.0884 12.39 15.0884H14.7C14.8114 15.0884 14.9182 15.0446 14.997 14.9665C15.0758 14.8885 15.12 14.7827 15.12 14.6724V9.38503C15.1203 9.32326 15.1062 9.26225 15.0789 9.20672C15.0516 9.15118 15.0118 9.1026 14.9625 9.06471L10.7541 5.80743C10.681 5.75243 10.5918 5.72266 10.5 5.72266C10.4082 5.72266 10.319 5.75243 10.2459 5.80743Z",
    fill: "#667689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.7fe6503432adc2cd616b19eb7954fbf8.svg";
export { ForwardRef as ReactComponent };